var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"oct-tabs",attrs:{"role":"tablist"}},_vm._l((_vm.items),function(item,i){return _c('oct-tab-item',{key:i,staticClass:"oct-tabs__item",attrs:{"text":item.text,"selected":item.selected},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.$emit('click:item', i)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }